module.exports = __webpack_public_path__ + "static/media/ploni-medium-aaa.27809ba4.eot";